'use strict';

var home = require('./home.js'); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
var editProfile = require('./edit-profile.js'); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
var visibility = require('./visibility.js'); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
var signup = require('./create-profile.js'); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
var afterEmail = require('./after-email.js'); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
var forwarding = require('./forwarding.js'); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
var express = require('./express-registration.js'); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
var reset = require('./reset.js');

var homev2 = require('./homev2.js');
var editProfileContactInformationName = require('./edit-profile-contact-information-name.js');
var editProfileContactInformation = require('./edit-profile-contact-information.js');
var editProfileDirectory = require('./edit-profile-directory.js');
var editProfilePrivacy = require('./edit-profile-privacy.js');
var editProfileProfessionalNetworking = require('./edit-profile-professional-networking.js');
var editProfileProfessionalProfile = require('./edit-profile-professional-profile.js');

home.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
signup.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
editProfile.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
visibility.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
afterEmail.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
forwarding.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
express.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod') deprecates probably?
reset.init();

homev2.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod')
editProfileContactInformationName.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod')
editProfileContactInformation.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod')
editProfileDirectory.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod')
editProfilePrivacy.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod')
editProfileProfessionalNetworking.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod')
editProfileProfessionalProfile.init(); // flagEnabled('profileV2Dev,profileV2QA,profileV2Prod')
